import MaintenanceNotice from "../pages/MaintenanceNotice.js";
import React from "react";

const MaintenanceBoundary = ({ children }) => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === "true";

  if (isMaintenance) {
    return (
      <MaintenanceNotice
        title={process.env.REACT_APP_MAINTENANCE_TITLE}
        message={process.env.REACT_APP_MAINTENANCE_MESSAGE}
        time={process.env.REACT_APP_MAINTENANCE_TIME}
        game={process.env.REACT_APP_MAINTENANCE_GAME_MODE}
      />
    );
  }

  return children;
};

export default MaintenanceBoundary;
